import { gql } from '@/utilities/gql';

export const AGGREGATE_PORTFOLIO_FRAGMENT = gql(`
  fragment aggregatePortfolioFields on AggregatePortfolio @_unmask {
    analysis {
      value
      roi
      roiValue
      holdingsCount
      capitalInvested
      currencyISO
      marketCountryISO
      benchmark
      benchmarkType
      estimatedYearlyDividend
      estimatedDividendYield
      estimatedYearlyDividendFuture1y
      estimatedYearlyDividendFuture1yUSD
      isAnalysisRestricted
      risksCount
      rewardsCount
    }
    snowflake {
      scores {
        value
        dividend
        future
        health
        past
      }
    }
  }
`);
